import {FieldConfig, FieldDataTypes, NameableInterface, nString, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {LocalDate} from "@js-joda/core";
import {BrandedResource, BrandedResourceFields} from "./branded-resource.interface";
import {RblNestResourceInterface} from "../rbl-resource.interface";
import {ResourceConfig} from "@hidat/huijs-resource";

export const PlaylistPageConfig = new ResourceConfig('PlaylistPage', 'playlist_pages')
  .addFields(BrandedResourceFields)
  .addFields([
    new FieldConfig('pageType'),
    new FieldConfig('priority', FieldDataTypes.INTEGER),
    new FieldConfig('parentPageId', FieldDataTypes.UID),
    new FieldConfig('accessMode', FieldDataTypes.INTEGER),
    new FieldConfig('urlStub'),
    new FieldConfig('startsAt', FieldDataTypes.DATE),
    new FieldConfig('endsAt', FieldDataTypes.DATE)
  ])

export interface PlaylistPageInterface extends RblNestResourceInterface, NameableInterface, BrandedResource {

  pageType: uString;
  priority: uNumber;
  parentPageId: Uuid | undefined;

  accessMode: uNumber;
  urlStub: nString;
  startsAt: LocalDate | undefined | null;
  endsAt: LocalDate | undefined | null;

}
